import type { Plugin } from "vue"
import { createPinia } from "pinia"
import { createApp } from "vue"
import App from "../App.vue"
import { createDashboardRouter } from "../router"

export interface CreateDashboardAppOptions {
  nuxtUi?: Plugin
}

export function createDashboardApp(options: CreateDashboardAppOptions = {}) {
  const pinia = createPinia()
  const router = createDashboardRouter(pinia)
  const app = createApp(App)

  app.use(pinia)
  app.use(router)

  if (options.nuxtUi) {
    app.use(options.nuxtUi)
  }

  return { app, pinia, router }
}
